import { render, staticRenderFns } from "./wallet-pay.vue?vue&type=template&id=69009f44&"
import script from "./wallet-pay.vue?vue&type=script&lang=js&"
export * from "./wallet-pay.vue?vue&type=script&lang=js&"
import style0 from "./wallet-pay.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports